import { isAxiosError } from "axios";
import type { CampaignOperationsConflict } from "@/marketing/models/campaignOperations";

/** Reads and words the 409 the server sends when someone else saved a field first. */
export class CampaignOperationsConflicts {
  /** Conflicting fields of a 409 save; empty for any other failure. */
  public static from(error: unknown): CampaignOperationsConflict[] {
    if (!isAxiosError(error) || error.response?.status !== 409) return [];
    const conflicts: unknown = (error.response.data as { conflicts?: unknown } | undefined)?.conflicts;
    if (!Array.isArray(conflicts)) return [];
    return conflicts.filter((conflict): conflict is CampaignOperationsConflict => typeof (conflict as { field?: unknown } | null)?.field === "string");
  }

  public static describe(campaignName: string, fieldLabel: string, conflict: CampaignOperationsConflict): string {
    return `${campaignName}: someone else changed ${fieldLabel} to ${CampaignOperationsConflicts.valueText(conflict.current)}. Showing their value.`;
  }

  public static valueText(value: unknown): string {
    if (value === null || value === undefined || value === "") return "empty";
    return typeof value === "string" ? value : JSON.stringify(value);
  }
}
